import {CloneWithPrototypes, GetErrorMessagesUnderElement} from "js-vextensions";
import {BaseComponent, GetDOM} from "react-vextensions";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {Column} from "react-vcomponents";

export type DetailsUI_Phase = "create" | "edit" | "view";
//export type DetailsUI_Base_Props<DataT, ClassType> = {baseData: DataT, phase: DetailsUI_Phase, style?, onChange?: (data: DataT, error: string, instance: ClassType)=>void};
export type DetailsUI_Base_Props<DataT> = {baseData: DataT, phase: DetailsUI_Phase, enabled?: boolean, style?, onChange?: (data: DataT, error: string, extras: {getValidationError: (()=>string|n)})=>void};
export type DetailsUI_Base_State<DataT> = {newData: DataT, dataError: string};

export const useDetailsUICore = <DataT,>(props: DetailsUI_Base_Props<DataT>)=>{
	const {baseData, phase, onChange} = props;
	const rootRef = useRef<Column|null>(null);

	const [newData, setNewData] = useState(CloneWithPrototypes(baseData));
	const [dataError, setDataError] = useState<string|null>(null);

	useEffect(()=>{
		setNewData(CloneWithPrototypes(baseData));
	}, [baseData]);

	const getValidationError = useCallback(()=>{
		const uiErrors = rootRef.current?.root ? GetErrorMessagesUnderElement(rootRef.current?.root) : []; // todo: make sure there's not a deeper problem behind this fix
		if (uiErrors.length) return uiErrors[0];
		/*const extraError = this.GetValidationError_Extras();
		if (extraError) return extraError;*/
		return null;
	}, [rootRef]);

	const onChange_final = useCallback(()=>{
		// new-data was mutated by whatever called OnChange, so make copy of newData so we can set it in state
		const error = getValidationError();
		const newData_copy = CloneWithPrototypes(newData);
		//this.GetNewData_PostProcess(newData_copy);

		if (onChange) onChange(newData_copy, error, {getValidationError}); //, this as any);
		setNewData(newData_copy);
		setDataError(error);
	}, [newData, onChange, getValidationError]);

	const helpers = useMemo(()=>({
		/**
		 * The recommended way to use this function is to provide a newData-changer function, eg: `Change(a=>a.name = newName)`
		 * But it also supports the old way, of just having the Change function be the after-effect of a direct mutation, eg: `Change(newData.name = newName)`
		*/
		Change: ((...args: any[])=>{
			if (args.length == 1 && typeof args[0] == "function") {
				const newDataChanger = args[0] as (newData: DataT)=>any;
				/*const newData_copy = CloneWithPrototypes(newData);
				newDataChanger(newData_copy);
				setNewData(newData_copy);*/
				newDataChanger(newData);
			}
			onChange_final();
		}) as {
			(newDataChanger: (newData: DataT)=>any): void;
			(..._: any[]): void;
		},
		creating: phase == "create",
		editing: phase == "edit",
		viewing: phase == "view",
		enabled: phase == "create" || phase == "edit",
	}), [onChange_final, phase]);

	return {rootRef, newData, helpers};
};